import { Routes } from '@angular/router';
import { UserComponent } from './user/user.component';
import { CategoriesComponent } from './categories/categories.component';
import { InputComponent } from './input/input.component';
import { TransactionsComponent } from './transactions/transactions.component';
import { BudgetComponent } from './budget/budget.component';
import { AuthGuardService } from './providers/auth-guard.service';
import { DashboardComponent } from './dashboard/dashboard.component';

export const routes: Routes = [
    { path: 'user', component: UserComponent },
    { path: 'dashboard', component: DashboardComponent, canActivate: [ AuthGuardService ]},
    { path: 'categories', component: CategoriesComponent, canActivate: [AuthGuardService] },
    { path: 'input', component: InputComponent, canActivate: [ AuthGuardService ] },
    { path: 'transactions', component: TransactionsComponent, canActivate: [AuthGuardService] },
    { path: 'budget', component: BudgetComponent, canActivate: [AuthGuardService] },
    { path: '**', redirectTo: '/user', pathMatch: 'full' },
];

